// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3TTUE","recent-search-label":"FCtVC","list-item":"_3mca1","item":"_3js8-","text":"_1cBa-","cross-icon":"_3AUjm"};